export const FEATURE_FLAGS = {
  TALKVIA_PROVIDER_IXC: 'talkvia_provider_ixc',
  TALKVIA_PROVIDER_MKAUTH: 'talkvia_provider_mkauth',
  TALKVIA_CORBAN: 'talkvia_corban',
  TALKVIA_CORBAN_FACTA_OFFLINE: 'talkvia_corban_facta_offline',
  TALKVIA_CORBAN_CLT_FGTS_QUERY: 'talkvia_corban_clt_fgts_query',
  TALKVIA_CORBAN_BENEFIT360: 'talkvia_corban_benefit360',
  TALKVIA_CORBAN_MULTICORBAN_VANGUARD: 'talkvia_corban_multicorban_vanguard',
  TALKVIA_CORBAN_INSS_MULTICORBAN: 'talkvia_corban_inss_multicorban',
  TALKVIA_CORBAN_INSS_VANGUARD: 'talkvia_corban_inss_vanguard',
  TALKVIA_CORBAN_CREDIT_ENGINE: 'talkvia_corban_credit_engine',
  TALKVIA_CORBAN_MANUAL_SIMULATORS: 'talkvia_corban_manual_simulators',
  TALKVIA_CORBAN_PROPOSAL_PIPELINE: 'talkvia_corban_proposal_pipeline',
  TALKVIA_LOGISTICS_INVENTORY_ROUTES: 'talkvia_logistics_inventory_routes',
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  ASSIGNMENT_V2: 'assignment_v2',
  ADVANCED_ASSIGNMENT: 'advanced_assignment',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  WHATSAPP_CAMPAIGNS: 'whatsapp_campaign',
  WHATSAPP_EMBEDDED_SIGNUP_FLOW: 'whatsapp_embedded_signup_inbox_creation',
  WHATSAPP_MANUAL_TRANSFER: 'whatsapp_manual_transfer',
  WHATSAPP_RECONFIGURE: 'whatsapp_reconfigure',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  DATA_IMPORT: 'data_import',
  DELAYED_AUTOMATIONS: 'delayed_automations',
  API_AND_WEBHOOKS: 'api_and_webhooks',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  LINEAR: 'linear_integration',
  CAPTAIN: 'captain_integration',
  CUSTOM_ROLES: 'custom_roles',
  CHATWOOT_V4: 'chatwoot_v4',
  CHANNEL_INSTAGRAM: 'channel_instagram',
  CHANNEL_TIKTOK: 'channel_tiktok',
  CHANNEL_VOICE: 'channel_voice',
  CONTACT_CHATWOOT_SUPPORT_TEAM: 'contact_chatwoot_support_team',
  CAPTAIN_CUSTOM_TOOLS: 'custom_tools',
  CAPTAIN_V2: 'captain_integration_v2',
  CAPTAIN_TASKS: 'captain_tasks',
  CAPTAIN_DOCUMENT_AUTO_SYNC: 'captain_document_auto_sync',
  SAML: 'saml',
  COMPANIES: 'companies',
  ADVANCED_SEARCH: 'advanced_search',
  CONVERSATION_REQUIRED_ATTRIBUTES: 'conversation_required_attributes',
  CONVERSATION_UNREAD_COUNTS: 'conversation_unread_counts',
  TALKVIA_AI_AGENT: 'talkvia_ai_agent',
};

export const PREMIUM_FEATURES = [
  FEATURE_FLAGS.AGENT_BOTS,
  FEATURE_FLAGS.AGENT_MANAGEMENT,
  FEATURE_FLAGS.ASSIGNMENT_V2,
  FEATURE_FLAGS.ADVANCED_ASSIGNMENT,
  FEATURE_FLAGS.AUTOMATIONS,
  FEATURE_FLAGS.CAMPAIGNS,
  FEATURE_FLAGS.CANNED_RESPONSES,
  FEATURE_FLAGS.CUSTOM_ATTRIBUTES,
  FEATURE_FLAGS.INBOX_MANAGEMENT,
  FEATURE_FLAGS.INTEGRATIONS,
  FEATURE_FLAGS.LABELS,
  FEATURE_FLAGS.MACROS,
  FEATURE_FLAGS.REPORTS,
  FEATURE_FLAGS.TEAM_MANAGEMENT,
  FEATURE_FLAGS.SLA,
  FEATURE_FLAGS.CAPTAIN,
  FEATURE_FLAGS.CAPTAIN_CUSTOM_TOOLS,
  FEATURE_FLAGS.CUSTOM_ROLES,
  FEATURE_FLAGS.AUDIT_LOGS,
  FEATURE_FLAGS.HELP_CENTER,
  FEATURE_FLAGS.SAML,
  FEATURE_FLAGS.CONVERSATION_REQUIRED_ATTRIBUTES,
];
